var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 } from "uuid";
const getDefaultApiBaseUrl = () => {
    var _a;
    if (typeof document == "undefined")
        return "";
    return ((_a = document.location) === null || _a === void 0 ? void 0 : _a.origin) || "";
};
const getDefaultHavenIdentityApiBaseUrl = () => {
    var _a, _b;
    if (typeof document == "undefined")
        return "";
    return ((_a = document.location) === null || _a === void 0 ? void 0 : _a.hostname.includes("devprod.haven.com")) ||
        ((_b = document.location) === null || _b === void 0 ? void 0 : _b.hostname.includes("haven-dev.com"))
        ? "https://id.haven-dev.com"
        : "https://id.haven.com";
};
export const identityApi = (config) => {
    var _a, _b, _c, _d;
    const client = config.client || "unknown";
    const identityUrl = (_a = config.identityUrl) !== null && _a !== void 0 ? _a : getDefaultApiBaseUrl();
    const sessionUrl = (_b = config.sessionUrl) !== null && _b !== void 0 ? _b : getDefaultApiBaseUrl();
    const havenIdentityUrl = (_c = config.havenIdentityUrl) !== null && _c !== void 0 ? _c : getDefaultHavenIdentityApiBaseUrl();
    const havenIdentityEnabled = (_d = config.havenIdentityEnabled) !== null && _d !== void 0 ? _d : true;
    const createHeaders = (sessionId) => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        if (sessionId)
            headers.append("SessionId", sessionId);
        return headers;
    };
    const havenIdentityEndSession = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield fetch(`${havenIdentityUrl}/identity/session/end`, {
            method: "POST",
            body: JSON.stringify({}),
            credentials: "include",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Accept: "application/json",
            }),
        });
        if (response.status !== 200)
            return "";
        const { xsrf } = (yield response.json());
        return xsrf;
    });
    const havenIdentityEndSessionConfirm = (xsrf) => __awaiter(void 0, void 0, void 0, function* () {
        yield fetch(`${havenIdentityUrl}/identity/session/end/confirm`, {
            method: "POST",
            body: new URLSearchParams({
                xsrf: xsrf,
                logout: "yes",
            }),
            credentials: "include",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            }),
        });
    });
    const silentHavenIdentityLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        if (typeof window !== "undefined" && window.localStorage) {
            Object.keys(window.localStorage)
                .filter((key) => key.startsWith("oidc"))
                .forEach((key) => {
                window.localStorage.removeItem(key);
            });
        }
        if (!havenIdentityEnabled)
            return;
        try {
            const xsrf = yield havenIdentityEndSession();
            yield havenIdentityEndSessionConfirm(xsrf);
        }
        catch (error) {
            return;
        }
    });
    const getSessionId = () => __awaiter(void 0, void 0, void 0, function* () {
        const uuid = v4();
        const headers = createHeaders();
        const session = yield fetch(`${sessionUrl}/session/api/session?id=${uuid}&client=identity_${client}`, {
            method: "POST",
            credentials: "include",
            headers,
        });
        if (session.status !== 200)
            throw new Error("oops");
        const body = (yield session.json());
        return body.sessionId;
    });
    const myAccountLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        const sessionId = yield getSessionId();
        const headers = createHeaders(sessionId);
        const response = yield fetch(`${identityUrl}/my-account/api/account/logout?client=identity_${client}`, {
            method: "DELETE",
            credentials: "include",
            headers,
        });
        if (response.status !== 200) {
            throw new Error(`Bad response from logout: ${response.status}`);
        }
    });
    const myAccountFetchIdentity = (params) => __awaiter(void 0, void 0, void 0, function* () {
        const sessionId = yield getSessionId();
        const headers = createHeaders(sessionId);
        const resp = yield fetch(`${identityUrl}/my-account/api/identity?client=${client}`, {
            method: "POST",
            credentials: "include",
            body: JSON.stringify(params),
            headers,
        });
        if (resp.status === 204) {
            return {
                data: undefined,
                session: sessionId,
            };
        }
        if (resp.status !== 200) {
            throw new Error(`Bad response from identity: ${resp.status}`);
        }
        const identityData = (yield resp.json());
        return {
            data: identityData,
            session: sessionId,
        };
    });
    return {
        fetchIdentity: (params) => __awaiter(void 0, void 0, void 0, function* () { return myAccountFetchIdentity(params); }),
        logout: () => __awaiter(void 0, void 0, void 0, function* () {
            yield myAccountLogout();
            yield silentHavenIdentityLogout();
            return true;
        }),
    };
};
